export { formatCurrency } from '../PropertyDetails/PropertyDetail.utils';

export const MIN_INVESTMENT = 100;

export const PRESET_AMOUNTS = [100, 500, 1000, 2500] as const;
export type PresetAmount = (typeof PRESET_AMOUNTS)[number];

/**
 * Steps the user actively navigates through.
 * 'processing' and 'complete' are transition states, not user decisions.
 */
export const NAVIGABLE_STEPS = ['amount', 'review', 'payment'] as const;
export type NavigableStep = (typeof NAVIGABLE_STEPS)[number];

/**
 * Returns the number of whole shares a given dollar amount buys.
 * Defensive: returns 0 for invalid inputs rather than NaN.
 */
export function calculateShares(amount: number, pricePerShare: number): number {
  if (pricePerShare <= 0 || !Number.isFinite(amount) || amount < 0) return 0;
  return Math.floor(amount / pricePerShare);
}

export function calculateProjectedReturn(amount: number, annualYield: number): number {
  return amount * annualYield;
}
